/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
import { User } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import { Row, Form, Button, Divider } from 'antd'
import { FormLabels, CustomCol } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import EmailChangedModal from '../EmailChangedModal/EmailChangedModal'
import { getTransformedDate, showNotification } from 'src/core/helpers'
import { personalDetailsSections } from './personal-details.form.sections'
import { resetUserPersonalDataState, updateUserLoginPersonalData } from 'src/features'

interface PersonalDetailsFormProps { user: User }

const PersonalDetailsForm: React.FC<PersonalDetailsFormProps> = ({ user }) => {
  const { t } = useTranslation()
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()

  const {
    loading: loadingSubmit,
    success: successEdition,
    newEmail: isNewEmail,
    error: errorEdition
  } = useAppSelector((state) => state.users.updatePersonalData)

  const onFinish = (values: any) => {
    const payload = {
      ...values,
      birth_date: getTransformedDate(values?.birth_date),
      is_business: user.is_business
    }
    dispatch(updateUserLoginPersonalData(payload, user?.email))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['email']: user?.email,
      ['first_name']: user?.first_name,
      ['last_name']: user?.last_name,
      ['id_number']: user?.id_number,
      ['street']: user?.street,
      ['city']: user?.city,
      ['postal_code']: user?.postal_code,
      ['state']: user?.state,
      ['country']: user?.country,
      ['birth_date']: user?.birth_date ? moment(new Date(user?.birth_date)) : null
    })
  }, [user])

  useEffect(() => {
    return (() => { dispatch(resetUserPersonalDataState()) })
  }, [dispatch])

  useEffect(() => {
    if (successEdition) {
      showNotification('success', t('settings.SuccessUpdatePersonalData'))
      dispatch(resetUserPersonalDataState())
      setIsButtonDisabled(true)
    }
  }, [successEdition])

  useEffect(() => {
    if (errorEdition === 'ALREADY_EXIST') {
      showNotification('error', t('settings.EmailExistsError'))
      dispatch(resetUserPersonalDataState())
    }
  }, [errorEdition])

  const handleValidation = (e: any, key: string) => {
    let value = !['country', 'birth_date'].includes(key) ? e.target.value : e
    if (key === 'birth_date') value = moment(new Date(e))
    return user ? setIsButtonDisabled(user[key] === value) : setIsButtonDisabled(false)
  }

  const formSections = personalDetailsSections(t, handleValidation, user)

  return (
    <>
      <Form
        name='basic'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        {formSections.map((section, idx) => <Row key={idx}>
          <CustomCol>
            <FormLabels {...section.formLabels} />
          </CustomCol>
          <CustomCol>
            <section.formComponent {...section.formProps} />
          </CustomCol>
        </Row>)}

        <Divider />

        {/*Buttons Content */}
        <div className='float-right'>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            shape='round'
            loading={loadingSubmit}
            disabled={isButtonDisabled}
          >
            {loadingSubmit ? t('settings.UpdatingFields') : t('settings.PersonalDataUpdate')}
          </Button>
        </div>
      </Form>

      <EmailChangedModal
        isModalVisible={isNewEmail}
      />
    </>
  )
}

export default PersonalDetailsForm
